import { Action, createReducer, on } from '@ngrx/store';
import {
    clearFacilitySearchResults,
    getMatchGroupPermissionsSuccess,
    loadFacilitySearchResultsFailure,
    loadFacilitySearchResultsSuccess,
    loadMatchGroupsFailure,
    loadMatchGroupsSuccess
} from '../actions/match-group.actions';
import { MatchGroupState } from '../state/match-group.state';

const initialState: MatchGroupState = {
    matchGroups: [],
    facilitySearch: [],
    permissions: null
};

const reducer = createReducer(
    initialState,

    on(loadMatchGroupsSuccess, (state, action) => ({
        ...state,
        matchGroups: action.response?.complianceMatchGroups
    })),

    on(loadMatchGroupsFailure, (state, action) => ({
        ...state,
        matchGroups: undefined
    })),

    on(loadFacilitySearchResultsSuccess, (state, action) => ({
        ...state,
        facilitySearch: action.response?.result
    })),

    on(clearFacilitySearchResults, (state, action) => ({
        ...state,
        facilitySearch: []
    })),

    on(loadFacilitySearchResultsFailure, (state, action) => ({
        ...state,
        facilitySearch: undefined
    })),

    on(getMatchGroupPermissionsSuccess, (state, action) => ({
        ...state,
        permissions: action.permissions
    }))
);

export function matchGroupReducer(state: MatchGroupState | undefined, action: Action) {
    return reducer(state, action);
}
